// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Badge } from "@/components/ui/badge";

const FIELD_TYPE_STYLES: Record<string, string> = {
  boolean:
    "bg-purple-100 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900",
  number: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  string: "bg-green-100 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  list: "bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900",
  json: "bg-teal-100 text-teal-700 border-teal-200 dark:bg-teal-950 dark:text-teal-300 dark:border-teal-900",
  enum: "bg-pink-100 text-pink-700 border-pink-200 dark:bg-pink-950 dark:text-pink-300 dark:border-pink-900",
};

export function FieldTypeBadge({ type }: { type: string }) {
  return (
    <Badge variant="outline" className={`font-normal ${FIELD_TYPE_STYLES[type] ?? ""}`}>
      {type}
    </Badge>
  );
}
